import React from 'react';

interface ThinkingIndicatorProps {
  text?: string;
}

export const ThinkingIndicator: React.FC<ThinkingIndicatorProps> = ({ text }) => {
  return (
    <div className="thinking-indicator">
      <span>{text}</span>
        <div className="thinking-dots">
          <div className="thinking-dot"></div>
          <div className="thinking-dot"></div>
          <div className="thinking-dot"></div>
       </div>
    </div>
  );
};